import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {DataService} from '../../services/data.service';
import { Subscription} from 'rxjs';

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-incident-types',
  templateUrl: './incident-types.component.html',
  styleUrls: ['./incident-types.component.scss']
})
export class IncidentTypesComponent implements OnInit, OnDestroy {
  private chart: am4charts.XYChart;
  observable: Subscription;
  collisionData: any;
  statesValues: any;
  refreshChart: any;

  constructor(private zone: NgZone, private dataService: DataService) {
    this.refreshChart = false;
  }

  ngOnInit() {
    this.observable = this.dataService.message.subscribe(data => {
      // console.log(data);
      this.loadData(data);
    });

  }
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
        this.observable.unsubscribe();
      }
    });
  }
  loadData(data) {
    this.statesValues = data['value'];
    this.refreshChart = data['remove'];
    if (this.refreshChart === true) {
      this.removeSeries();
    }
    this.collisionData = [['276', '234', '292', '178'],
      ['198', '267', '225', '318']];
    this.loadChart();
  }

  removeSeries() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  loadChart() {
    this.chart = am4core.create('incidentdiv', am4charts.XYChart);
    this.chart.data = [{
      'country': 'Side Collision',
      'visits': this.collisionData[this.statesValues][0]
    }, {
      'country': 'Rear Collision',
      'visits': this.collisionData[this.statesValues][1]
    }, {
      'country': 'Front Collision',
      'visits': this.collisionData[this.statesValues][2]
    }, {
      'country': 'Others',
      'visits': this.collisionData[this.statesValues][3]
    }];
    const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'country';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;

    categoryAxis.renderer.labels.template.adapter.add('dy', function (dy, target) {
      if (target.dataItem && target.dataItem.index && 2 === 2) {
        return dy + 25;
      }
      return dy;
    });

    const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

// Create series
    const series = this.chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'visits';
    series.dataFields.categoryX = 'country';
    series.name = 'Visits';
    series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';
    series.columns.template.fillOpacity = .8;

    const columnTemplate = series.columns.template;
    columnTemplate.strokeWidth = 2;
    columnTemplate.strokeOpacity = 1;
  }

}
